import api from './api';

export default {
  /**
   * Get list of current created medications
   *
   * @return Promise<Object>
   */
  getMedications() {
    return api()
      .get('/meds-suggested-routes')
      .then(response => response.data);
  },

  /**
   * Get list of medications.
   *
   * @return Promise<Object>
   */
  getAvailableMedications() {
    return api()
      .get('/lookups/meds-suggested')
      .then(response => response.data);
  },

  /**
   * Delete medication
   *
   * @return Promise<Object>
   */
  deleteMedication(medicationId) {
    return api()
      .delete(`/meds-suggested-routes/${medicationId}`)
      .then(response => response.data);
  },

  /**
   * Create new medication.
   *
   * @return Promise<Object>
   */
  createMedication(data) {
    return api()
      .post('/meds-suggested-routes', data)
      .then(response => response.data);
  },

  /**
   * Create new medication.
   *
   * @return Promise<Object>
   */
  updateMedication(medicationId, data) {
    return api()
      .put(`/meds-suggested-routes/${medicationId}`, data)
      .then(response => response.data);
  },
};
